import { z } from "zod";

// Environment-variable validation for the frontend (master context §7.2).
const envSchema = z.object({
  REACT_APP_BACKEND_URL: z.string().url("REACT_APP_BACKEND_URL must be a valid URL"),
});

const parsed = envSchema.safeParse({
  REACT_APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
});

if (!parsed.success) {
  // Surface loudly in dev; never silently continue with a broken config.
  // eslint-disable-next-line no-console
  console.error("Invalid frontend environment configuration:", parsed.error.flatten().fieldErrors);
}

export const env = {
  backendUrl: process.env.REACT_APP_BACKEND_URL ?? "",
};

export const API_BASE = env.backendUrl;
